import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux'
import store from './data/store'

import Root from 'routes/root'
import PageNotFound from 'routes/page_not_found';
import Home from 'routes/home';
import OnlineQuotes from 'routes/online_quotes';
import GroupHealth from 'routes/group_health';

import OurCarriers from 'routes/our_carriers';
import FAQs from 'routes/faqs';
import AboutUs from 'routes/about_us';
import ContactUs from 'routes/contact_us';

import Agent from 'routes/agent';
import Blog from 'routes/blog';
import SectionLayout from 'components/layouts/SectionLayout';
import BlogItem from 'routes/blog/blog_item';
import TermsAndCondition from 'routes/terms_and_condition';
import PrivacyPolicy from 'routes/privacy_policy';
import PriceQuote from 'routes/price_quote';
import PriceQuoteCalifornia from 'routes/price_quote_california';
import GHNextStep from 'routes/gh_next_step';

import Enrollment from 'routes/enrollment';
import GroupCensus from 'routes/group_census';
import InsidersGuide from 'routes/resources/insiders_guide';
import HealthPlanCalculator from 'routes/health_plan_calculator';
import LumpSumBenefits from 'routes/lump_sum_benefits';


const pages = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <PageNotFound />,
    children: [
      { index: true, element: <Home /> },
      { path: "online-quotes", element: <OnlineQuotes /> },
      { path: "group-health", element: <GroupHealth /> },
      { path: "our-carriers", element: <OurCarriers /> },
      { path: "faqs", element: <FAQs /> },
      { path: "about-us", element: <AboutUs /> },
      { path: "contact-us", element: <ContactUs /> },
      { path: "agent", element: <Agent /> },
      { path: "blog", element: <Blog /> },
      { path: "blog/:blogId", element: <SectionLayout content={<BlogItem />} /> },
      { path: "privacy-policy", element: <PrivacyPolicy /> },
      { path: "terms-and-condition", element: <TermsAndCondition /> },
      { path: "price-quote", element: <PriceQuote /> },
      { path: "price-quote-california", element: <PriceQuoteCalifornia /> },
      { path: "gh-next-step", element: <GHNextStep /> },
      { path: "group-census", element: <GroupCensus /> },
      { path: "enrollment", element: <Enrollment /> },
      { path: "resources", element: <Navigate to="/resources/insiders-guide" replace /> },
      { path: "resources/insiders-guide", element: <InsidersGuide /> },
      { path: "calculators/health-plan-quote", element: <HealthPlanCalculator /> },
      { path: "health-plan-calculator", element: <Navigate to="/calculators/health-plan-quote" replace /> },
      { path: "calculator", element: <Navigate to="/calculators/health-plan-quote" replace /> },
      { path: "calculators", element: <Navigate to="/calculators/health-plan-quote" replace /> },
      { path: "calculators/lump-sum-benefits", element: <LumpSumBenefits /> },
      { path: "lump-sum-benefits", element: <Navigate to="/calculators/lump-sum-benefits" replace /> },
      { path: "lump-sum", element: <Navigate to="/calculators/lump-sum-benefits" replace /> },
      { path: "*", element: <PageNotFound /> },
    ],
  },
])

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={pages} />
    </Provider>
  </React.StrictMode>
)
